<template>
  <v-card :class="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row dense>
      <v-col cols="12" sm="8" md="9" lg="9">
        <v-text-field
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Search anything here ..."
          single-line
          solo
          hide-seaClientss
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="3" lg="3">
        <ul>
          <li>
            <span class="text--ash">Total Client:</span>
            <span>123</span>
          </li>

          <li>
            <span class="text--ash">Total Commission:</span>
            <span>1500.50</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card
          class="rounded-0 elevation-0"
          :class="$vuetify.theme.dark ? 'blue-darken-5' : 'white-lighten-2'"
        >
          <v-sheet
            class="transactionTable levelOneTable"
            :class="$vuetify.theme.dark ? 'blue-lighten-1 ' : 'white-lighten-1'"
          >
            <v-data-table
              :headers="headers"
              :items="desserts"
              :search="search"
              :items-per-page="10"
            >
              <template v-slot:item.symb="{ item }">
                <div class="user-profile d-block">
                  <div class="profile-image">
                    <v-badge
                      bordered
                      overlap
                      small
                      icon="mdi-star-outline"
                      size="10"
                      :class="verifyBadge(item.symb)"
                    >
                      <v-avatar size="32" class="indigo-darken-2">
                        <span class="text-small">L3</span>
                      </v-avatar>
                    </v-badge>
                  </div>
                </div>
              </template>
              <template v-slot:item.clientName="{ item }">
                <router-link class="text-capitalize text--green" :to="item.clientLink">
                  {{ item.clientName }}
                </router-link>
              </template>
              <template v-slot:item.ibName="{ item }">
                <router-link class="text-capitalize ib-links" :to="item.ibLink">
                  {{ item.ibName }}
                </router-link>
              </template>
              <template v-slot:item.commission="{ item }">
                <span class="text-capitalize text-decoration-none text--green">
                  {{ item.commission }}
                </span>
              </template>
              
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Symb",
          align: "center",
          value: "symb",
        },
        { text: "Client Name", value: "clientName", align: "center" },
        { text: "IB Name", value: "ibName", align: "center"  },
        { text: "Reg Date & TIme", value: "dateAndTime", align: "center"  },
        { text: "Acc", value: "accType", align: "center"  },
        { text: "Balance", value: "balance", align: "center"  },

        { text: "Commission", value: "commission", align: "center"  },
        
      ],
      desserts: [
        {
          symb: "isPresentLevelBadge",
          clientName: "Adam",
          clientLink: '/adam',
          ibName: "Abu Bakar",
          ibLink: "/abu-bakar",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
          commission: "10 EUR",
         
        },
        {
          symb: "isPresentLevelBadge",
          clientName: "Edris",
          clientLink: '/edris',
          ibName: "Umor",
          ibLink: "/umor",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
          commission: "10 EUR",
          
        },
        {
          symb: "",
          clientName: "Musa",
          clientLink: '/musa',
          ibName: "Osman",
          ibLink: "/osman",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
          commission: "10 EUR",
          
        },
        {
          symb: "isPresentLevelBadge",
          clientName: "Ibrahim",
          clientLink: '/ibrahim',
          ibName: "Ali",
          ibLink: "/ali",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
         commission: "10 EUR",
          
        },
        {
          symb: "",
          clientName: "Yousuf",
          clientLink: '/yousuf',
          ibName: "Abbas",
          ibLink: "/abbas",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
         commission: "10 EUR",
         
        },
        {
          symb: "isPresentLevelBadge",
          clientName: "Esmail",
          clientLink: '/esmail',
          ibName: "Yazid",
          ibLink: "/yazid",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
          commission: "10 EUR",
         
        },
        {
          symb: "",
          clientName: "Yakub",
          clientLink: '/yakub',
          ibName: "Muabia",
          ibLink: "/muabia",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
          commission: "10 EUR",
          
        },
        {
          symb: "isPresentLevelBadge",
          clientName: "Nuh",
          clientLink: '/nuh',
          ibName: "Huraira",
          ibLink: "/huraira",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
          commission: "10 EUR",
          
        },
        {
          symb: "isPresentLevelBadge",
          clientName: "Suaib",
          clientLink: '/suaib',
          ibName: "Hamza",
          ibLink: "/hamza",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
          commission: "10 EUR",
          
        },
        {
          symb: "isPresentLevelBadge",
          clientName: "Harun",
          clientLink: '/harun',
          ibName: "Khalid",
          ibLink: "/khalid",
          dateAndTime: "25.08.2020-8:32 pm",
          accType: "2132 (test)",
          balance: "100 EUR",
          commission: "10 EUR",
         
        },
      ],
    };
  },
  methods: {
    verifyBadge(symb) {
      if (symb === "isPresentLevelBadge") return "show-badge";
      else return "hide-badge";
    },
    
  },
};
</script>
